module.exports = __webpack_public_path__ + "media/assets/faria_products/add_icon-3c696dc32df7d001c0078e3db42380ebf20dcbb9fbbd013cee3920ab06b17100.svg";